import {Component, OnInit} from '@angular/core';
import {FieldType} from '@ngx-formly/core';
import {Observable} from 'rxjs';
import {map, take} from 'rxjs/operators';
import {UsageType} from '@dcp/configurator';
import {ConfiguratorProductService} from '@app/product/configurator/services/configurator-product.service';
import {DcpProductDataService} from '@app/product/data/dcp-product-data.service';
import {TransactionTextsService} from '../services/transaction-texts.service';
import {UntilDestroy, untilDestroyed} from '@ngneat/until-destroy';
import {TransactionTypeTexts} from '@app/checkout/order-confirmation/order-confirmation-list-item/order-confirmation-order-item.model';

@UntilDestroy()
@Component({
  selector: 'dcp-eu-access',
  templateUrl: './eu-access.component.html',
  styleUrls: ['./eu-access.component.scss']
})
export class FormlyEuAccessComponent extends FieldType implements OnInit {

  public usageTypes$: Observable<UsageType[]>;
  public transactionTypeTexts$: Observable<TransactionTypeTexts>;

  constructor(
    private configuratorProductService: ConfiguratorProductService,
    private productDataService: DcpProductDataService,
    private transactionTextsService: TransactionTextsService,
  ) {
    super();
  }

  ngOnInit(): void {
    this.transactionTypeTexts$ = this.transactionTextsService.getTransactionTypeTexts$();
    this.usageTypes$ = this.getUsageTypes();
    this.usageTypes$.pipe(take(1), untilDestroyed(this)).subscribe(usageTypes => {
      const hasEuAccess = usageTypes.some(usageType => usageType?.technicalName === 'EU-Access');
      const previousSelection = this.model.data['EU-Access'] === 'true';
      if (hasEuAccess) {
        this.formControl.setValue(previousSelection);
      }
    });
  }

  private getUsageTypes(): Observable<UsageType[]> {
    return this.configuratorProductService.getVariant$().pipe(
      map(product => this.productDataService.getUsageTypes(product?.data) || [])
    );
  }
}
